<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0C2.69147 0 0 2.69147 0 6C0 9.30853 2.69147 12 6 12C9.30853 12 12
    9.30853 12 6C12 2.69147 9.30853 0 6 0ZM8.85352
    9.10345C8.75601 9.20096 8.62802 9.25003 8.50003 9.25003C8.37204 9.25003 8.24396
    9.20096 8.14655 9.10345L5.64651 6.60352C5.55249
    6.51004 5.50003 6.38297 5.50003 6.25003V3C5.50003
    2.72351 5.72397 2.50003 6 2.50003C6.27603 2.50003 6.49997 2.72351 6.49997 3V6.04303L8.85352
    8.39648C9.04898 8.59204 9.04898
    8.90799 8.85352 9.10345Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconClock'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconClock.vue